import { MapPin, Navigation, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
export default function OurServiceArea() {
  return <section data-section-id="224256" id="our-service-area" className="relative w-full h-[600px] bg-background border-y border-border overflow-hidden">
      {}
      <div className="absolute inset-0 w-full h-full bg-muted/50">
        <iframe title="Service Area Map" src="https://maps.google.com/maps?q=New%20York%20City&t=&z=11&ie=UTF8&iwloc=&output=embed" width="100%" height="100%" style={{
        border: 0
      }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="w-full h-full grayscale contrast-150 opacity-70 dark:opacity-50 pointer-events-auto" />
        {}
        <div className="absolute inset-0 pointer-events-none bg-gradient-to-r from-background/90 via-background/40 to-transparent md:w-1/2" />
      </div>

      {}
      <div className="absolute inset-x-4 bottom-6 md:inset-auto md:top-1/2 md:left-16 md:-translate-y-1/2 md:w-[400px] z-10">
        <Card className="shadow-2xl border-primary/20 bg-background/95 backdrop-blur-lg rounded-lg">
          <CardHeader className="pb-4">
            <CardTitle className="font-default text-3xl font-bold tracking-tight flex items-center gap-2 text-foreground uppercase">
              <MapPin className="size-6 text-primary" />
              Service Area
            </CardTitle>
            <CardDescription className="text-lg text-foreground/70 font-default">
              Our fleet is ready to shift. We provide professional relocation 
              services across the metropolitan area and beyond.
            </CardDescription>
          </CardHeader>
          <CardContent className="grid gap-5 pb-6">
            <div className="flex items-start gap-4 p-3 bg-accent/10 border border-border rounded-md">
              <MapPin className="size-5 text-primary shrink-0 mt-0.5" />
              <div className="flex flex-col">
                <span className="font-default font-bold text-primary text-xs uppercase tracking-widest mb-1">
                  Primary Hub
                </span>
                <span className="font-default text-foreground font-medium">
                  Central Logistics Center, NY
                </span>
              </div>
            </div>
            <div className="flex items-start gap-4 p-3 bg-accent/10 border border-border rounded-md">
              <Phone className="size-5 text-primary shrink-0 mt-0.5" />
              <div className="flex flex-col">
                <span className="font-default font-bold text-primary text-xs uppercase tracking-widest mb-1">
                  Dispatch Line
                </span>
                <span className="font-default text-foreground font-medium">800-SHIFT-NOW</span>
              </div>
            </div>
          </CardContent>
          <CardFooter>
            <Button asChild className="w-full font-default font-bold tracking-widest h-12 text-base bg-primary hover:bg-primary/90 text-primary-foreground transition-all duration-300 rounded-md">
              <Link to="/GetQuotePage">
                <Navigation className="size-5 mr-2" />
                CHECK AVAILABILITY
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>;
}